import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useLayoutEffect,
} from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
// import { useNavigate } from 'react-router-dom';
import { ISubHeaderProps } from "../SubHeader/SubHeader";
import { IPageProps } from "../Page/Page";
import AuthContext from "../../contexts/authContext";
import { getLoginObjDetails } from "../../redux/login/login.selector";

interface IPageWrapperProps {
  isProtected?: boolean;
  title?: string;
  description?: string;
  children:
    | ReactElement<ISubHeaderProps>[]
    | ReactElement<IPageProps>
    | ReactElement<IPageProps>[];
  className?: string;
}
const PageWrapper = forwardRef<HTMLDivElement, IPageWrapperProps>(
  ({ isProtected = true, title, description, className, children }, ref) => {
    const loginData = useSelector(getLoginObjDetails);
    const { CompanyName } = loginData || {};

    useLayoutEffect(() => {
      const siteName =
        CompanyName && CompanyName.trim() !== ""
          ? CompanyName
          : process.env.REACT_APP_SITE_NAME || "Phoenix";

      const titleElement = document.querySelector("title") as HTMLTitleElement;
      if (titleElement) {
        titleElement.text = `${title ? `${title} | ` : ""}${siteName}`;
      }

      const metaDescription = document.querySelector(
        'meta[name="description"]',
      ) as HTMLMetaElement;
      if (metaDescription) {
        metaDescription.setAttribute(
          "content",
          description || process.env.REACT_APP_META_DESC || "",
        );
      }
    }, [title, description, CompanyName]);

    const { user } = useContext(AuthContext);

    // const navigate = useNavigate();
    useEffect(() => {
      if (isProtected && user === "") {
        // navigate(`../${pages.id}`);
      }
      return () => {};
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <div
        ref={ref}
        className={classNames("page-wrapper", "container-fluid", className)}
      >
        {children}
      </div>
    );
  },
);
PageWrapper.displayName = "PageWrapper";

export default PageWrapper;
